import { Routes } from '@angular/router';
import { NotFoundComponent } from './errors/not-found/not-found.component';
import { AutenticarComponent } from './pages/autenticar/autenticar.component';


export const routes: Routes = [

    {
        path: 'pages/usuarios/autenticar',
        component: AutenticarComponent
    },



    {
        path: 'admin',
        loadChildren: () => import('./modules/admin/admin.module').then(m => m.AdminModule)
    },

    {
        path: '',
        pathMatch: 'full',
        redirectTo: '/pages/usuarios/autenticar'
    },
    {
        path: '**',
        component: NotFoundComponent
    }
];
